var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return [0, 2].includes(_vm.status)
    ? _c(
        "div",
        [
          _c(
            "el-form",
            {
              ref: "basicForm",
              attrs: {
                model: _vm.ruleForm,
                rules: _vm.rules,
                "label-width": "120px",
                size: "small",
                "label-position": _vm.$i18n.locale !== "zh" ? "top" : "right",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.businessT"),
                            prop: "claimsNode",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "form-bottom",
                              staticStyle: { width: "100%" },
                              attrs: {
                                id: "claimsNode",
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                disabled:
                                  [2].includes(_vm.status) && _vm.id !== "",
                              },
                              on: { change: _vm.handelClaimsNode },
                              model: {
                                value: _vm.ruleForm.claimsNode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "claimsNode", $$v)
                                },
                                expression: "ruleForm.claimsNode",
                              },
                            },
                            _vm._l(_vm.claimNode, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.name, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("compensationManagement.ClaimType"),
                            prop: "claimsType",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                id: "claimsType",
                                placeholder: _vm.$t(
                                  "operationCenter.PleaseSelect"
                                ),
                              },
                              on: { change: _vm.handelClaimType },
                              model: {
                                value: _vm.ruleForm.claimsType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "claimsType", $$v)
                                },
                                expression: "ruleForm.claimsType",
                              },
                            },
                            [
                              _c("el-option", {
                                key: 1,
                                attrs: {
                                  label: _vm.$t(
                                    "compensationManagement.TimeoutNotClosedLoop"
                                  ),
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                key: 2,
                                attrs: {
                                  label: _vm.$t(
                                    "compensationManagement.FalseSigningForDelivery"
                                  ),
                                  value: 2,
                                },
                              }),
                              _c("el-option", {
                                key: 3,
                                attrs: {
                                  label: _vm.$t(
                                    "compensationManagement.TimeDelay"
                                  ),
                                  value: 3,
                                },
                              }),
                              _vm.isVisible
                                ? _c("el-option", {
                                    key: 5,
                                    attrs: {
                                      label: _vm.$t(
                                        "compensationManagement.confirmationOfLoss"
                                      ),
                                      value: 5,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "compensationManagement.AmountOfClaim"
                            ),
                            prop: "claimAmount",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              id: "claimAmount",
                              disabled: _vm.isDisabled,
                              placeholder: _vm.$t("GlobalSetObj.pleaseInput"),
                              clearable: "",
                            },
                            model: {
                              value: _vm.ruleForm.claimAmount,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "claimAmount", $$v)
                              },
                              expression: "ruleForm.claimAmount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Resource.applicant") } },
                        [
                          _c("el-input", {
                            attrs: {
                              id: "applicant",
                              maxlength: "40",
                              "show-word-limit": "",
                              placeholder: _vm.$t(
                                "GlobalSetObj.pleaseInputContent"
                              ),
                            },
                            model: {
                              value: _vm.ruleForm.applicant,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.ruleForm,
                                  "applicant",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "ruleForm.applicant",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Resource.Reviewer") } },
                        [
                          _c("UserSelectCmp", {
                            staticClass: "form-bottom",
                            attrs: {
                              "user-name": _vm.userName,
                              "is-user-name": true,
                            },
                            model: {
                              value: _vm.ruleForm.reviewer,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "reviewer", $$v)
                              },
                              expression: "ruleForm.reviewer",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "compensationManagement.CauseOfClaim"
                            ),
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              id: "claimReason",
                              type: "textarea",
                              maxlength: "2000",
                              "show-word-limit": "",
                              autosize: { minRows: 2, maxRows: 4 },
                              placeholder: _vm.$t(
                                "GlobalSetObj.pleaseInputContent"
                              ),
                            },
                            model: {
                              value: _vm.ruleForm.claimReason,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "claimReason", $$v)
                              },
                              expression: "ruleForm.claimReason",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "uploadFile",
                          attrs: {
                            label: _vm.$t("customerManagements.enclosure"),
                            prop: "attachmentUrl",
                          },
                        },
                        [
                          _c("UploadCmp", {
                            attrs: {
                              drag: true,
                              multiple: true,
                              "file-arr": _vm.fileArr,
                              "auto-upload": true,
                              limit: 5,
                            },
                            on: { change: _vm.onFileChange },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _c(
        "div",
        [
          _c(
            "el-form",
            {
              staticClass: "edit-form",
              attrs: {
                "label-width": "120px",
                size: "small",
                "label-position": _vm.$i18n.locale !== "zh" ? "top" : "right",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.businessT") + "：",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                (_vm.claimNode[_vm.ruleForm.claimsNode] &&
                                  _vm.claimNode[_vm.ruleForm.claimsNode]
                                    .name) ||
                                  ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label:
                              _vm.$t("compensationManagement.ClaimType") + "：",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                (_vm.CLAIMS_TYPE[_vm.ruleForm.claimsType] &&
                                  _vm.CLAIMS_TYPE[_vm.ruleForm.claimsType]
                                    .name) ||
                                  ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label:
                              _vm.$t("compensationManagement.AmountOfClaim") +
                              "：",
                          },
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.ruleForm.claimAmount))])]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("Resource.applicant") + "：" },
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.ruleForm.applicant))])]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("Resource.Reviewer") + "：" },
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.ruleForm.reviewerUsername)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label:
                              _vm.$t("compensationManagement.CauseOfClaim") +
                              "：",
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                display: "inline-block",
                                "max-height": "100px",
                                "overflow-y": "scroll",
                                width: "100%",
                                "word-break": "break-all",
                              },
                            },
                            [_vm._v(_vm._s(_vm.ruleForm.claimReason))]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "uploadFile",
                          attrs: {
                            label:
                              _vm.$t("customerManagements.enclosure") + "：",
                          },
                        },
                        [
                          _vm._l(_vm.fileArr, function (item) {
                            return _c(
                              "li",
                              { key: item.url },
                              [
                                _c(
                                  "el-link",
                                  {
                                    attrs: {
                                      type: "primary",
                                      target: "_blank",
                                      href: item.url,
                                    },
                                  },
                                  [
                                    _vm._v(_vm._s(item.name)),
                                    _c("i", {
                                      staticClass:
                                        "el-icon-view el-icon--right",
                                    }),
                                  ]
                                ),
                              ],
                              1
                            )
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }